import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import * as api from '../../services/related_entity_type/api_related_entity_type';
import * as common from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListRelatedEntityTypeSaga(feathersApp) {
	yield takeLatest("FETCH_LIST_RELATED_ENTITY_TYPE", callFetchListRelatedEntityType, feathersApp);
}
function* callFetchListRelatedEntityType(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'related_entity_type'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveRelatedEntityTypeSaga(feathersApp) {
	yield takeEvery("SAVE_RELATED_ENTITY_TYPE", callSaveRelatedEntityType, feathersApp);
}
function* callSaveRelatedEntityType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveRelatedEntityType, feathersApp, params);

		yield common.doneSaveRecord(result, 'Relationship was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListRelatedEntityType(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteRelatedEntityTypeFromListSaga(feathersApp) {
	yield takeEvery('DELETE_RELATED_ENTITY_TYPE_FROM_LIST', callDeleteRelatedEntityTypeFromList, feathersApp);
}

function* callDeleteRelatedEntityTypeFromList(feathersApp, action) {
	yield deleteRelatedEntityType(feathersApp, action);
	yield delay(2000);
	yield callFetchListRelatedEntityType(feathersApp, { silent: true });
}

function* deleteRelatedEntityType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteRelatedEntityType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.RELATED_ENTITY_TYPE } });
			yield callFetchListRelatedEntityType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteRelatedEntityTypeSaga(feathersApp) {
	yield takeEvery('DELETE_RELATED_ENTITY_TYPE', callDeleteRelatedEntityType, feathersApp);
}

function* callDeleteRelatedEntityType(feathersApp, action) {
	const result = yield deleteRelatedEntityType(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/relationship_type');
	}
}

export function* fetchRelatedEntityTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_RELATED_ENTITY_TYPE_BY_ID', callFetchRelatedEntityTypeForEdit, feathersApp);
}

function* callFetchRelatedEntityTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.RELATED_ENTITY_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchRelatedEntityTypeById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
